import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default function initScheme() {
  const scheme = document.querySelector('.services__scheme');
  if (!scheme) return;

  const images = scheme.querySelectorAll('img');
  if (images.length < 2) return;

  const offsets = [2, -2, 4, 14];

  // Scroll-linked parallax is pure decoration with no resting hidden state —
  // matchMedia() simply doesn't register it when reduced motion is requested.
  const mm = gsap.matchMedia();
  mm.add('(prefers-reduced-motion: no-preference)', () => {
    images.forEach((img, i) => {
      gsap.fromTo(img,
        { yPercent: offsets[i] },
        {
          yPercent: -offsets[i],
          ease: 'none',
          scrollTrigger: {
            trigger: scheme,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        }
      );
    });
  });
}
